import {invokeApig} from "../../libs/awsLib";
import {getUserApiData} from "../../utils/UserUtils";
import Paths from "../paths";

export function getResults(
    category,
    rows,
    resultType,
    valueKeys,
    week,
    year,
    type,
    calcType,
    signal,
    {ClientID, LocalUserID} = {}
) {
    const {_LocalUserID, _ClientID} = getUserApiData({ClientID, LocalUserID});
    return invokeApig({
        ...Paths.getResults({clientID: _ClientID, localUserID: _LocalUserID}),
        body: {
            category,
            rows,
            resultType,
            valueKeys,
            week,
            year,
            type,
            calcType,
        },
        signal,
    });
}
